import React from 'react';
import { ActivityList } from '../../components/Pleri/components/Activity/ActivityList';

interface TaskActivitiesProps {
  taskId: string;
}

export const TaskActivities: React.FC<TaskActivitiesProps> = ({ taskId }) => {
  return <ActivityList sourceId={taskId} />;
};
